(() => {
  const form = document.getElementById('hire-gate');
  const calendar = document.getElementById('hire-calendar');
  if (!form || !calendar) return;
  form.addEventListener('submit', (event) => {
    event.preventDefault();
    if (!form.reportValidity()) return;
    if (calendar.hidden) {
      const frame = calendar.querySelector('iframe');
      frame.src = frame.dataset.src;
      calendar.hidden = false;
      const embed = document.createElement('script');
      embed.src = 'https://embed.acuityscheduling.com/js/embed.js';
      document.body.appendChild(embed);
    }
    document.getElementById('hire-calendar-title').focus();
  });
})();
